import {connect} from 'react-redux';
import {GelDragDrop as Component} from './GelDragDrop';
import {
  saveGelDragDropPrediction
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  return {
    gelDragDropPrediction: state.notebook.protocolSection.scene.gelDragDropPrediction,
  }

}

function mapDispatchToProps(dispatch) {
  return {
    saveGelDragDropPrediction: (data) => {
      dispatch(saveGelDragDropPrediction(data))
    }
  };
}

export const GelDragDrop = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
